import type { UserRole } from "@/features/users/user.type";

export type AppRouteKey =
  | "home"
  | "cases"
  | "farms"
  | "shop"
  | "locations"
  | "report"
  | "farmers"
  | "profile";

type RoleRoutes = Record<UserRole, Partial<Record<AppRouteKey, string>>>;

export const ROLE_ROUTES: RoleRoutes = {
  farmer: {
    home: "/farmer",
    cases: "/farmer/cases",
    farms: "/farmer/farms",
    shop: "/farmer/shop",
    report: "/farmer/report",
    profile: "/farmer/profile",
  },
  admin: {
    home: "/admin",
    cases: "/admin/cases",
    farmers: "/admin/farmers",
    locations: "/admin/locations",
    profile: "/admin/profile",
  },
  extension_officer: {
    home: "/officer",
    cases: "/officer/cases",
    farmers: "/officer/farmers",
    profile: "/officer/profile",
  },
  veterinary_officer: {
    home: "/officer",
    cases: "/officer/cases",
    farmers: "/officer/farmers",
    profile: "/officer/profile",
  },
  county_supervisor: {
    home: "/supervisor",
    cases: "/supervisor/cases",
    farmers: "/supervisor/farmers",
    profile: "/supervisor/profile",
  },
  customer: {
    home: "/shop",
    cases: "/shop",
    profile: "/shop/profile",
  },
};

export function getRoleRoute(
  role: UserRole | null | undefined,
  key: AppRouteKey,
) {
  if (!role) return "/login";
  return ROLE_ROUTES[role]?.[key] ?? "/login";
}

export function getRoleHomePath(role?: UserRole | null) {
  return getRoleRoute(role, "home");
}

export function getRoleCasesPath(role?: UserRole | null) {
  return getRoleRoute(role, "cases");
}

export function getRoleFarmsPath(role?: UserRole | null) {
  return getRoleRoute(role, "farms");
}

export function getRoleShopPath(role?: UserRole | null) {
  return getRoleRoute(role, "shop");
}

export function getRoleLocationsPath(role?: UserRole | null) {
  return getRoleRoute(role, "locations");
}

export function getRoleReportPath(role?: UserRole | null) {
  return getRoleRoute(role, "report");
}

export function getRoleFarmersPath(role?: UserRole | null) {
  return getRoleRoute(role, "farmers");
}

export function getRoleProfilePath(role?: UserRole | null) {
  return getRoleRoute(role, "profile");
}
